var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-tenant-resource-log-modal',{attrs:{"row-data":_vm.rowData}})
}
var staticRenderFns = []

export { render, staticRenderFns }